<template>
  <div>
    <div class="sm:block hidden cta-speakol-parent mr-6">
      <router-link to="/campaigns/create">
        <speakol-main-button @click="$gtag.event('Create_Campaign')" id="header-create-campaign-button"
                             buttonText="Create Campaign">
          <template v-slot:icon>
            <vs-icon class="create-campaign-icon" icon-pack="speakol" icon="speakol-create-campaign"></vs-icon>
          </template>
        </speakol-main-button>
      </router-link>
    </div>

    <router-link to="/campaigns/create">
      <button class="border-none bg-transparent sm:hidden create-campaign-mobile-icon mr-6 mt-1">
        <vs-icon icon-pack="speakol" icon="speakol-create-campaign" size="1.5x" class=""/>
      </button>
    </router-link>
  </div>
</template>

<script>
import SpeakolMainButton from '@/components/speakol-template/SpeakolMainButton.vue'

export default {
  components: {
    SpeakolMainButton
  }
}
</script>

<style lang="scss" scoped>
.create-campaign-mobile-icon {
  color: rgba(146, 146, 157, 1);
}
</style>
